import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcaBreadcrumbComponent } from './components/eca-breadcrumb/eca-breadcrumb.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {RouterModule} from '@angular/router';
//import {BreadcrumbModule} from 'ng-uikit-pro-standard';
import { BreadcrumbModule } from 'primeng/breadcrumb';



@NgModule({
  declarations: [EcaBreadcrumbComponent],
  exports: [
    EcaBreadcrumbComponent,
  ],
  imports: [
    CommonModule,
    BreadcrumbModule,
    FontAwesomeModule,
    RouterModule
  ]
})
export class EcaBreadcrumbModule { }
